import Account from './Account';

export default Account;
